import * as React from 'react';
import { IgcTextareaComponent as Component } from 'igniteui-webcomponents';
import type { IgcTextareaComponentEventMap } from 'igniteui-webcomponents';
import { type EventName, createComponent } from '../react-props.js';

/**
 * This element represents a multi-line plain-text editing control,
 * useful when you want to allow users to enter a sizeable amount of free-form text,
 * for example a comment on a review or feedback form.
 * @slot  - Text content from the default slot will be used as the value of the component.
 * @slot prefix - Renders content before the input.
 * @slot suffix - Renders content after input.
 * @slot helper-text - Renders content below the input.
 * @slot value-missing - Renders content when the required validation fails.
 * @slot too-long - Renders content when the maxlength validation fails.
 * @slot too-short - Renders content when the minlength validation fails.
 * @slot custom-error - Renders content when setCustomValidity(message) is set.
 * @slot invalid - Renders content when the component is in invalid state (validity.valid = false).
 * @fires igcInput - Emitted when the control receives user input.
 * @fires igcChange - Emitted when the a change to the control value is committed by the user.
 * @csspart container - The main wrapper that holds all main input elements of the textarea.
 * @csspart input - The native input element of the igc-textarea.
 * @csspart label - The native label element of the igc-textarea.
 * @csspart prefix - The prefix wrapper of the igc-textarea.
 * @csspart suffix - The suffix wrapper of the igc-textarea.
 * @csspart helper-text - The helper text wrapper of the igc-textarea.
 * @class
 */
export const IgrTextarea = /* @__PURE__ */ createComponent({
  tagName: 'igc-textarea',
  displayName: 'IgrTextarea',
  elementClass: Component,
  react: React,
  events: {
    onInput: 'igcInput' as EventName<IgcTextareaComponentEventMap['igcInput']>,
    onChange: 'igcChange' as EventName<
      IgcTextareaComponentEventMap['igcChange']
    >,
  },
});

export type IgrTextarea = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrTextareaModule = Component;
